module.exports = __webpack_public_path__ + "img/sbl0007.69cc3c3a.png";